// extracted by mini-css-extract-plugin
export default {"custom-themes":"CustomizedThemeTab_custom-themes__Ib4bw","title":"CustomizedThemeTab_title__kx5wV"};